// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import {  ListItemFactory } from "@app/shared";
import { CategoryModel, DocumentModel, MenuModel, RoomContentPropertyDto } from "@app/catalog";

export class RoomContentPropertyModel 
{
    public id: string = "";    
    public name: WritableSignal<string>;
    public code: WritableSignal<string>;
    public thumbnailUrl: WritableSignal<string>;
    public categories: WritableSignal<CategoryModel[]>;
    public documents: WritableSignal<DocumentModel[]>;
    public hasImageError: WritableSignal<boolean>;
    public menus: WritableSignal<MenuModel>;
    

    constructor()
    {
        this.name = signal<string>(null);
        this.code = signal<string>(null);
        this.thumbnailUrl = signal<string>(null);
        this.categories = signal<CategoryModel[]>([]);
        this.documents = signal<DocumentModel[]>([]);
        this.hasImageError = signal<boolean>(false);
        this.menus = signal<MenuModel>(null);
    }

    public handleImageError() {
        this.hasImageError.set(true);
    }

    public static fromDto(dto: RoomContentPropertyDto)
    {
        let roomContent = new RoomContentPropertyModel();

        roomContent.id = dto.id;
        roomContent.name.set(dto.name);
        roomContent.code.set(dto.code);
        roomContent.thumbnailUrl.set(dto.thumbnailUrl);
        roomContent.documents.set((dto.documents || []).map(doc => DocumentModel.fromDto(doc)));
        roomContent.menus.set(MenuModel.fromDto(dto.menus));

        //TODO:DIW:At somepoint the selected categories could be passed in so CategoryModel.fromDto can have isChecked set properly.
        roomContent.categories.set(dto.categories.map(cat=>CategoryModel.fromDto(cat, false)).sort((a, b) => a.name().localeCompare(b.name())))    
        return roomContent;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<RoomContentPropertyModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<RoomContentPropertyModel>(this.name, this.id, this, selected);

}
